import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import "../../assets/css/login.scss";

import { Button, Error, Image, Input, Label } from "../../Components";
import Icon from "../../assets/icons/Icon";
import { loginUser } from "../../store/user/user-action";
import { loginSchema } from "../../Schema/LoginSchema";
import { FaRegUserCircle } from "react-icons/fa";
import { GrLock } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { dispatch } from "../../store";

const Login = () => {
  const [showHide, setShowHide] = useState(true);
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state.ui);

  const { values, touched, errors, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        Username: "",
        Password: "",
      },
      validationSchema: loginSchema,
      onSubmit: (values) => {
        loginUser(dispatch, values, navigate);
      },
    });

  return (
    <>
      <section className="login_app">
        <div className="login-container">
          <div className="login-header">
            <div className="logo_img">
              <Link to="/login">
                <Image
                  className="logo_icon"
                  src="/assets/images/logo.svg"
                  alt="logo icon"
                  fetchpriority="high"
                  loading="eager"
                />
              </Link>
            </div>
            <p>Log In</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <Label className="form-label" for="Username">
                Username
              </Label>

              <FaRegUserCircle className="icon_box" />

              <Input
                type="text"
                className="form-control"
                id="Username"
                name="Username"
                placeholder="Enter username"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.Username}
                autoFocus={true}
              />
              {errors.Username && touched.Username && (
                <Error>{errors.Username}</Error>
              )}
            </div>
            <div className="input-group">
              <Label className="form-label" for="Password">
                Password
              </Label>
              <GrLock className="icon_box" />
              <Input
                type={`${!showHide ? "text" : "password"}`}
                className="form-control"
                name="Password"
                id="Password"
                placeholder="Enter password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.Password}
                autoComplete="on"
              />

              <div className="eye_icon" onClick={() => setShowHide(!showHide)}>
                {showHide ? <Icon name="FaEye" /> : <Icon name="FaEyeSlash" />}
              </div>
              {errors.Password && touched.Password && (
                <Error>{errors.Password}</Error>
              )}
            </div>
            <div className="input-group">
              <Button
                className="login-button"
                type="submit"
                // icon="FaSignInAlt"
                isDisabled={isLoading}
              >
                {isLoading ? "Loading..." : "sign in"}
              </Button>
            </div>
          </form>
          {/* <div className="form-footer">
            <span>
              This is Trading Application with full trading features, designed
              solely for educational purposes.
            </span>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Login;
